import {EditableFieldModel} from "@white-label/components/page-builder/models/edit-component.model";
import {FieldType} from "@white-label/components/page-builder/models/model.map";

export class BannerModel {
    imageUrl = new EditableFieldModel('banner_url', FieldType.image, '/assets/hero-banner/esp_banner.jpg');
    videoUrl = new EditableFieldModel('video_url', FieldType.image, '');
    title = new EditableFieldModel('title', FieldType.text, 'Hero banner title');
    subtitle = new EditableFieldModel('subtitle', FieldType.text, 'Herro banner subtitle');
    description = new EditableFieldModel('description', FieldType.text, 'Herro banner description');
    buttonText = new EditableFieldModel('action_button_text', FieldType.text, 'Play with me');
    buttonLink = new EditableFieldModel('navigate_to_product', FieldType.link, '/');

    fieldsMap = [this.title, this.subtitle, this.description, this.imageUrl, this.videoUrl, this.buttonText, this.buttonLink];

    constructor(data?: {title?: any, subtitle?: any, description?: any, imageUrl?: any,
                videoUrl?: any, buttonText?: any, buttonLink?: any}) {
        if(data?.title){
            this.title.value = data.title.value;
        }
        if(data?.subtitle){
            this.subtitle.value = data.subtitle.value;
        }
        if(data?.description){
            this.description.value = data.description.value;
        }
        if(data?.imageUrl){
            this.imageUrl.value = data.imageUrl.value;
        }
        if(data?.videoUrl){
            this.videoUrl.value = data.videoUrl.value;
        }
        if(data?.buttonText){
            this.buttonText.value = data.buttonText.value;
        }
        if(data?.buttonLink){
            this.buttonLink.value = data.buttonLink.value;
        }
    }
}